"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var react_intl_1 = require("react-intl");
var ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
var lab_1 = require("@material-ui/lab");
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
var DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
var DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var fieldsProps_1 = require("./utils/fieldsProps");
function TTableSelectPreset(props) {
    var currentPreset = props.currentPreset, presets = props.presets, onChangePreset = props.onChangePreset, onDeletePreset = props.onDeletePreset, isAdmin = props.isAdmin;
    var _a = react_1.useState(null), presetForRemoving = _a[0], setPresetForRemoving = _a[1];
    var handleCancel = react_1.useCallback(function () {
        setPresetForRemoving(null);
    }, [setPresetForRemoving]);
    var handleOk = react_1.useCallback(function () {
        presetForRemoving && onDeletePreset(presetForRemoving);
        setPresetForRemoving(null);
    }, [onDeletePreset, setPresetForRemoving, presetForRemoving]);
    var handleOpen = react_1.useCallback(function (preset) { return function (e) {
        e.stopPropagation();
        setPresetForRemoving(preset);
    }; }, [setPresetForRemoving]);
    var handleChangePreset = react_1.useCallback(function (event, value) {
        onChangePreset(value);
    }, [onChangePreset]);
    var renderOption = react_1.useCallback(function (p) { return (react_1.default.createElement(core_1.Grid, { container: true, justify: "space-between", alignItems: "center" },
        react_1.default.createElement(core_1.Grid, { xs: 11, item: true }, p.title),
        p.id !== 'default' && (isAdmin || !p.shared) && !p.autoSaved ? (react_1.default.createElement(core_1.Grid, { xs: 1, item: true },
            react_1.default.createElement(core_1.IconButton, { onClick: handleOpen(p) },
                react_1.default.createElement(icons_1.DeleteForever, null)))) : null)); }, [handleOpen]);
    var intl = react_intl_1.useIntl();
    var renderInput = react_1.useCallback(function (params) { return (react_1.default.createElement(core_1.TextField, __assign({}, params, { placeholder: intl.formatMessage({ id: 'ttable.byDefault', defaultMessage: 'По умолчанию' }) }, fieldsProps_1.textFieldProps))); }, []);
    var getOptionLabel = react_1.useCallback(function (p) { return p.title; }, []);
    var getOptionSelected = react_1.useCallback(function (o, v) { return o.id === v.id; }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(lab_1.Autocomplete, { disableClearable: true, popupIcon: react_1.default.createElement(ExpandMore_1.default, null), noOptionsText: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.resultsOption", defaultMessage: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B" }), ChipProps: {
                deleteIcon: react_1.default.createElement(icons_1.Clear, null),
                size: 'small',
            }, clearText: "", closeText: "", openText: "", value: currentPreset, options: presets.sort(function (presetA, presetB) {
                return presetA.shared === presetB.shared ? 0 : presetA.shared ? 1 : -1;
            }), onChange: handleChangePreset, getOptionLabel: getOptionLabel, getOptionSelected: getOptionSelected, renderOption: renderOption, renderInput: renderInput, groupBy: function (option) { return (option.shared ? 'Общие' : ''); } }),
        react_1.default.createElement(Dialog_1.default, { id: "confirm-deletion-preset", fullWidth: true, maxWidth: "xs", open: !!presetForRemoving },
            react_1.default.createElement(DialogTitle_1.default, null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.deletionPreset", defaultMessage: "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u0435\u0441\u0435\u0442\u0430" })),
            react_1.default.createElement(DialogContent_1.default, null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.confirmDeletionPreset", values: { preset: presetForRemoving === null || presetForRemoving === void 0 ? void 0 : presetForRemoving.title }, defaultMessage: "\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0440\u0435\u0441\u0435\u0442 \"" + (presetForRemoving === null || presetForRemoving === void 0 ? void 0 : presetForRemoving.title) + "\"?" })),
            react_1.default.createElement(DialogActions_1.default, null,
                react_1.default.createElement(Button_1.default, { autoFocus: true, onClick: handleCancel, color: "primary" },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.cancel", defaultMessage: "\u041E\u0442\u043C\u0435\u043D\u0430" })),
                react_1.default.createElement(Button_1.default, { onClick: handleOk, color: "secondary", variant: "contained" },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.confirm", defaultMessage: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C" }))))));
}
exports.default = TTableSelectPreset;
